import { TextEditorOutputProps } from '@procore/core-react/dist/_typedoc/TextEditorOutput/TextEditorOutput.types.json';
import * as React from 'react';
export default {
  TextEditorOutputProps,
  React
};